import { makeStyles } from '@material-ui/core/styles';

export const useTableWithSearchStyles = makeStyles((theme: any) => ({
  root: {
    width: '100%',
    height: '100%',
    marginTop: theme.spacing ? theme.spacing(2) : 16,
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flex: 1,
  },
  searchBar: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 16,
    '& .MuiSvgIcon-root':{
        fill: "none"
    },
    '& .MuiIconButton-root': {
      background: 'none !important',
      marginRight: 0,
      '&:hover': {
        background: 'none !important',
      },
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: 0,
    },
  },
  searchInput: {
    minWidth: 400,
    flex: 1,
    maxWidth: 600,
    fontSize: 12
  },
  tableContainer: {
    maxHeight: "23vh", // reduced height for scrollable table
    height: "23vh",
    overflow: 'auto',
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #EEEEEE',
    borderRadius: 4,
  },
  table: {
    width: '100%',
    minWidth: 300,
    tableLayout: 'auto',
    flex: 1,
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: '1px solid #EEEEEE',
  },
  tableCell: {
    borderBottom: '1px solid #EEEEEE',
    '&:last-child': {
      borderRight: 'none',
    },
  },
  tableHeadCell: {
    borderBottom: '2px solid #EEEEEE',
    background: '#fafafa',
    fontWeight: 600,
    '&:last-child': {
      borderRight: 'none',
    },
  },
}));
